<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item prop="channelId">
        <template v-slot:label>
          所属渠道
        </template>
        <search-channel-select
          v-model="form.channelId"
          :channelType="2"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item prop="dspId">
        <template v-slot:label>
          所属广告主
        </template>
        <search-dsp-select
          v-model="form.dspId"
          :dspType="2"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item prop="linkId">
        <template v-slot:label>
          投放链接
        </template>
        <search-dsp-link-select
          :dsp-id="form.dspId"
          v-model="form.linkId"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="监测名称" prop="monitorName">
        <el-input
          v-model="form.monitorName"

          type="textarea"
          autosize
          placeholder="请输入监测名称"
        />
      </el-form-item>

      <el-form-item label="投放单价" prop="unitPrice">
        <el-input
          v-model="form.unitPrice"

          autosize
          placeholder="请输入投放单价"
        />
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="form.remark"

          type="textarea"
          autosize
          placeholder="请输入备注"
        />
      </el-form-item>

    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" >取消</el-button>
      <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {addMonitor, updateMonitor} from '@/api/manage/link/link'
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchDspLinkSelect from '@/components/SearchDspLinkSelect'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import {linkTypeList} from "@/const/link-type";

const form = {
  channelId: undefined,
  dspId: undefined,
  monitorId: undefined,
  // linkId: 111,
  monitorName: undefined,
  remark: undefined,
  unitPrice: undefined
}
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 800
    },
    data: Object
  },
  emits: ['submit'],
  components: {
    SearchDspSelect,
    SearchDspLinkSelect,
    SearchChannelSelect
  },
  data() {
    var validateNumber = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('输入不能为空'));
        }
        if (!/^(\d+(\.\d+)?)$/.test(value)) {
          return callback(new Error('请输入正确的数字格式'));
        } else {
          callback();
        }
      };
    return {

      dialogStatus: false,
      submitLoading: false,
      header: {},
      form: Object.assign({}, form),
      rules: {
        channelId: [{required: true, message: '请选择渠道', trigger: 'blur'}],
        dspId: [{required: true, message: '请选择广告主', trigger: 'blur'}],
        linkId: [{required: true, message: '请选择投放链接', trigger: 'blur'}],
        monitorName: [{required: true, message: '请输入监测名称', trigger: 'blur'}],
        unitPrice: [{required: true, message: '请输入投放单价', trigger: 'blur'},{validator: validateNumber, trigger: 'blur'}]
      },
      budgetList: [],
      linkTypeList: linkTypeList
    }
  },
  computed: {
    dialogTitle() {
      return (this.title ? this.title : '') + (this.form.monitorId ? '编辑' : '新增')
    }
  },
  created() {
  },
  methods: {
    show(data) {
      this.dialogStatus = true
      if (data) {
        // 深拷贝，避免列表 row 节点改变了
        let parseData = JSON.parse(JSON.stringify(data))
        const { linkId } = parseData;
        parseData.linkId = undefined
        // 这块会触发 SearchDspLinkSelect watch dspId
        this.form = Object.assign({}, parseData)
        this.$nextTick(()=>{
          // DOM 更新完后在执行 ，能确保在 created 后执行，实现 SearchDspLinkSelect watch 执行顺序，先执行 dspId, 在实现 modelValue
          this.form.linkId = linkId
        })
      }
    },
    close() {
      this.dialogStatus = false
      this.reset()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.monitorId) {
            this.updateMonitor(this.form)
          } else {
            this.addMonitor(this.form)
          }
        }
      })
    },
    addMonitor(form) {
      this.submitLoading = true
      addMonitor(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    updateMonitor(form) {
      this.submitLoading = true
      updateMonitor(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset() {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
